import React, { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAppContext } from '../AppContext';
import LoadingSpinner from './LoadingSpinner';

const SharedMediaModal = ({ isOpen, onClose, chatId }) => {
  const { t } = useTranslation();
  const { db, appId } = useAppContext();
  const [media, setMedia] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isOpen || !chatId) return;

    const mediaQuery = query(
      collection(db, `artifacts/${appId}/private_chats/${chatId}/messages`),
      where('imageUrl', '!=', null),
      orderBy('imageUrl'),
      orderBy('timestamp', 'desc')
    );

    const unsubscribe = onSnapshot(mediaQuery, (snapshot) => {
      const mediaItems = snapshot.docs.map(doc => doc.data().imageUrl);
      setMedia(mediaItems);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [isOpen, chatId, db, appId]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="bg-gray-800 p-6 rounded-lg shadow-xl max-w-2xl w-full text-white">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-purple-300 font-playfair">{t('sharedMedia.title')}</h3>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-700">
            <LucideIcons.X size={24} />
          </button>
        </div>
        {isLoading ? (
          <LoadingSpinner message={t('sharedMedia.loading')} />
        ) : (
          <div className="grid grid-cols-3 md:grid-cols-4 gap-4 max-h-[60vh] overflow-y-auto custom-scrollbar">
            {media.length > 0 ? (
              media.map((url, index) => (
                <div key={index} className="aspect-square bg-gray-700 rounded-lg overflow-hidden">
                  <img src={url} alt={t('sharedMedia.altText', { index: index + 1 })} className="w-full h-full object-cover" />
                </div>
              ))
            ) : (
              <p className="col-span-full text-center text-gray-400">{t('sharedMedia.empty')}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SharedMediaModal;
